
import { Fragment } from 'react';
import Login from './Authentication/Login';
import MainFooter from "./MainFooter";
import classes from './Root.module.css';
import MainNavigation from "./MainNavigation";
const Home = () => {
    return (
        <Fragment>
               <MainNavigation /> 
               <main className={classes.content}>
                        <Login/>
                        </main>
                <MainFooter />
        </Fragment>
    );
}

export default Home;